module.exports = __webpack_public_path__ + "assets/840459058d3420f7b095cda9f613deb3.jpg";